import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtasSociosComponent } from './atas-socios.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { AtasSociosService } from './atas-socios.service';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        PoPageDynamicTableModule,
        PoPageDynamicEditModule,
        SharedModule
  ],
  declarations: [AtasSociosComponent],
  providers: [AtasSociosService]
})
export class AtasSociosModule { }

